module.exports = __webpack_public_path__ + "static/img/bg-en.57ad5080.png";